import axios from 'axios';

const API_BASE_URL = import.meta.env.VITE_API_URL || 'http://localhost:5000/api';

const api = axios.create({
    baseURL: API_BASE_URL,
    headers: {
        'Content-Type': 'application/json',
    },
});

api.interceptors.request.use((config) => {
    const token = localStorage.getItem('token');
    if (token) {
        config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
});

const BASE = '/off-market-stays';

/**
 * Get all active off-market stays (paginated).
 * @param {{ page?: number, limit?: number, search?: string, countryCode?: string, sort?: string }} params
 */
export const getAllOffMarketStays = async (params = {}) => {
    try {
        const response = await api.get(BASE, { params });
        return response.data;
    } catch (error) {
        console.error('Error fetching off-market stays:', error);
        throw error;
    }
};

/**
 * Get a single off-market stay by Mongo _id.
 */
export const getOffMarketStayById = async (id) => {
    try {
        const response = await api.get(`${BASE}/${id}`);
        return response.data;
    } catch (error) {
        console.error('Error fetching off-market stay:', error);
        throw error;
    }
};

/**
 * Get distinct countries (for filter dropdown).
 */
export const getOffMarketStayCountries = async () => {
    try {
        const response = await api.get(`${BASE}/countries`);
        return response.data;
    } catch (error) {
        console.error('Error fetching off-market stay countries:', error);
        throw error;
    }
};

export default {
    getAllOffMarketStays,
    getOffMarketStayById,
    getOffMarketStayCountries,
};
